(() => {
  if (window.__hgImageTapQuickAddBound) return;
  window.__hgImageTapQuickAddBound = true;

  const cartSelectors = [
    'a[href$="/cart"]',
    'a[href*="/cart?"]',
    '[data-cart-icon]',
    '.header__icon--cart',
    '.header-cart',
    'cart-drawer-opener',
    '[aria-controls*="cart" i]'
  ];

  const getVisibleElement = (selectors) => {
    for (const selector of selectors) {
      const elements = document.querySelectorAll(selector);
      for (const element of elements) {
        const rect = element.getBoundingClientRect();
        const style = window.getComputedStyle(element);
        if (
          rect.width > 0 &&
          rect.height > 0 &&
          style.visibility !== 'hidden' &&
          style.display !== 'none'
        ) {
          return element;
        }
      }
    }
    return null;
  };

  const findProductImage = (link) => {
    const card = link.closest('product-card, .card, .card-wrapper');
    if (!card) return null;

    const images = card.querySelectorAll(
      '.product-card-variant-image:not(.hidden), .product-card-featured-image, .card-media img, img'
    );

    for (const image of images) {
      const rect = image.getBoundingClientRect();
      const style = window.getComputedStyle(image);
      if (
        rect.width > 0 &&
        rect.height > 0 &&
        style.visibility !== 'hidden' &&
        style.display !== 'none' &&
        Number(style.opacity || 1) > 0
      ) {
        return image;
      }
    }

    return null;
  };

  const pulseCart = (cartTarget) => {
    if (!cartTarget || typeof cartTarget.animate !== 'function') return;

    cartTarget.animate(
      [
        { transform: 'scale(1)' },
        { transform: 'scale(1.16)' },
        { transform: 'scale(1)' }
      ],
      {
        duration: 260,
        easing: 'cubic-bezier(.2,.8,.2,1)'
      }
    );
  };

  const flyImageToCart = (link) => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sourceImage = findProductImage(link);
    const cartTarget = getVisibleElement(cartSelectors);

    if (!sourceImage || reduceMotion || typeof sourceImage.animate !== 'function') {
      return Promise.resolve();
    }

    const sourceRect = sourceImage.getBoundingClientRect();
    const targetRect = cartTarget
      ? cartTarget.getBoundingClientRect()
      : {
          left: window.innerWidth - 30,
          top: 22,
          width: 1,
          height: 1
        };

    const clone = sourceImage.cloneNode(true);
    const computed = window.getComputedStyle(sourceImage);

    Object.assign(clone.style, {
      position: 'fixed',
      left: `${sourceRect.left}px`,
      top: `${sourceRect.top}px`,
      width: `${sourceRect.width}px`,
      height: `${sourceRect.height}px`,
      margin: '0',
      objectFit: computed.objectFit || 'cover',
      objectPosition: computed.objectPosition || 'center',
      borderRadius: computed.borderRadius || '12px',
      pointerEvents: 'none',
      zIndex: '2147483647',
      transformOrigin: 'center center',
      boxShadow: '0 16px 38px rgba(0, 0, 0, 0.28)',
      willChange: 'transform, opacity, filter'
    });

    clone.removeAttribute('loading');
    clone.removeAttribute('srcset');
    clone.setAttribute('aria-hidden', 'true');
    document.body.appendChild(clone);

    const sourceCenterX = sourceRect.left + sourceRect.width / 2;
    const sourceCenterY = sourceRect.top + sourceRect.height / 2;
    const targetCenterX = targetRect.left + targetRect.width / 2;
    const targetCenterY = targetRect.top + targetRect.height / 2;
    const dx = targetCenterX - sourceCenterX;
    const dy = targetCenterY - sourceCenterY;

    const animation = clone.animate(
      [
        {
          transform: 'translate3d(0, 0, 0) scale(1)',
          opacity: 1,
          filter: 'brightness(1)'
        },
        {
          transform: `translate3d(${dx * 0.12}px, ${Math.min(-24, dy * 0.08)}px, 0) scale(1.04)`,
          opacity: 0.98,
          filter: 'brightness(1.08)',
          offset: 0.2
        },
        {
          transform: `translate3d(${dx}px, ${dy}px, 0) scale(0.08)`,
          opacity: 0,
          filter: 'brightness(1.12)'
        }
      ],
      {
        duration: 720,
        easing: 'cubic-bezier(.22,.8,.2,1)',
        fill: 'forwards'
      }
    );

    return animation.finished
      .catch(() => undefined)
      .then(() => {
        clone.remove();
        pulseCart(cartTarget);
      });
  };

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('a.hg-image-tap-quick-add');
    if (!link) return;

    if (event.target.closest('modal-opener, button, [role="button"], input, select, textarea')) {
      return;
    }

    const variantId = link.dataset.hgVariantId;
    if (!variantId || link.dataset.hgAdding === 'true') return;

    event.preventDefault();
    link.dataset.hgAdding = 'true';
    link.setAttribute('aria-busy', 'true');

    const root = window.Shopify?.routes?.root || '/';
    const flightPromise = flyImageToCart(link);

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }]
        })
      });

      if (!response.ok) {
        throw new Error(`Cart add failed with status ${response.status}`);
      }

      await flightPromise;
      window.location.assign(`${root}cart`);
    } catch (error) {
      console.error('[HardGuard] Image-tap quick add failed.', error);
      window.location.assign(link.href);
    } finally {
      link.dataset.hgAdding = 'false';
      link.removeAttribute('aria-busy');
    }
  });
})();
